export const environment = {
  production: false,
  apiUrl: 'https://demo.api.barachapchap.com/api/v1',
  clientAppUrl: 'barachapchap://bookings',
};
